<p-toast></p-toast>
<div class="h-screen flex overflow-hidden relative lg:static">
  @if (showShell()) {
    <div
      id="app-sidebar-9"
      class="app-sidebar hidden lg:block shrink-0 absolute lg:relative left-0 top-0 z-10 border-r border-surface lg:border-r-0 select-none h-full bg-surface-switch-0 transition-[width] duration-300 ease-out max-lg:w-64"
      [class.w-64]="!sidebarCompressed()"
      [class.w-[50px]]="sidebarCompressed()"
    >
      <div class="flex flex-col h-full overflow-x-hidden overflow-y-auto">
        <div class="flex items-center justify-between m-1.5 my-4 shrink-0">
          <div class="flex items-center shrink-0 pl-0.5">
            @if (!sidebarCompressed()) {
              <div class="min-w-0 overflow-hidden flex items-center ml-1">
                <span
                  class="app-logo app-logo--wordmark h-7 bg-primary"
                  role="img"
                  aria-label="Logo"
                ></span>
              </div>
            } @else {
              <div
                class="group relative z-10 w-[34px] h-[34px] shrink-0 bg-surface-switch-0"
                [class.cursor-pointer]="!canHover() && sidebarCompressed()"
                [attr.role]="
                  !canHover() && sidebarCompressed() ? 'button' : null
                "
                [attr.tabindex]="!canHover() && sidebarCompressed() ? 0 : null"
                [attr.aria-label]="
                  !canHover() && sidebarCompressed() ? 'Expand sidebar' : null
                "
                (click)="onSidebarLogoClick($event)"
                (keydown.enter)="onSidebarLogoClick($event)"
                (keydown.space)="onSidebarLogoClick($event)"
              >
                <div
                  class="absolute inset-0 flex items-center justify-center opacity-100 transition-opacity duration-200"
                  [class.lg:group-hover:opacity-0]="sidebarCompressed()"
                >
                  <span
                    class="app-logo app-logo--mark h-7 bg-primary"
                    role="img"
                    aria-label="Logo"
                  ></span>
                </div>
                <button
                  type="button"
                  class="absolute top-1/2 left-1/2 hidden lg:inline-flex -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-lg p-1 text-surface-switch-500 opacity-0 transition-opacity duration-200 pointer-events-none cursor-pointer hover:bg-surface-switch-100"
                  [class.lg:group-hover:opacity-100]="sidebarCompressed()"
                  [class.lg:group-hover:pointer-events-auto]="
                    sidebarCompressed()
                  "
                  pTooltip="Expand sidebar"
                  tooltipPosition="right"
                  [showDelay]="150"
                  aria-label="Expand sidebar"
                  (click)="expandSidebar()"
                >
                  <span
                    class="material-symbols-outlined text-[24px] leading-none"
                  >
                    left_panel_open
                  </span>
                </button>
              </div>
            }
          </div>
          @if (!sidebarCompressed()) {
            <button
              type="button"
              class="shrink-0 hidden lg:inline-flex items-center justify-center rounded-lg p-1 text-surface-switch-500 cursor-pointer hover:bg-surface-switch-100 transition-colors"
              pTooltip="Compress sidebar"
              tooltipPosition="right"
              [showDelay]="150"
              aria-label="Compress sidebar"
              (click)="compressSidebar()"
            >
              <span class="material-symbols-outlined text-[24px] leading-none">
                left_panel_close
              </span>
            </button>
          }
        </div>
        <div class="flex-1 flex flex-col p-1.5 pt-0 overflow-x-hidden min-h-0">
          @for (item of navItems(); track item.label; let index = $index) {
            <a
              [routerLink]="item.routerLink"
              (click)="setActiveItem(index)"
              class="flex h-[38px] items-center justify-start gap-2.5 px-2.5 rounded-lg w-full min-w-0 overflow-x-hidden transition-colors duration-200 hover:bg-surface-switch-100"
              [pTooltip]="item.label"
              tooltipPosition="right"
              [showDelay]="150"
              [tooltipDisabled]="!sidebarCompressed()"
              [class.bg-surface-switch-50]="index === activeItem()"
              [class.text-primary]="index === activeItem()"
              [class.text-surface-switch-700]="index !== activeItem()"
              [hidden]="!item.visible"
              [attr.aria-label]="item.label"
            >
              <i [class]="item.icon + ' shrink-0 text-lg! leading-none'"></i>
              @if (!sidebarCompressed()) {
                <span
                  class="grid grid-cols-1 overflow-x-hidden min-w-0"
                  animate.enter="enter-sidebar-text-animation"
                  animate.leave="leave-sidebar-text-animation"
                >
                  <span
                    class="min-w-0 overflow-x-hidden text-sm font-medium leading-normal whitespace-nowrap"
                    >{{ item.label }}</span
                  >
                </span>
              }
            </a>
          }
        </div>
        <div class="shrink-0 overflow-x-hidden p-1.5">
          @if (userEmail()) {
            <button
              type="button"
              (click)="openProfileDialog()"
              class="flex h-[38px] items-center justify-start gap-2.5 px-2.5 rounded-lg transition-colors duration-200 w-full min-w-0 overflow-x-hidden text-surface-switch-600 cursor-pointer hover:bg-surface-switch-50 hover:text-surface-switch-900"
              pTooltip="Profile"
              tooltipPosition="right"
              [showDelay]="150"
              [tooltipDisabled]="!sidebarCompressed()"
              [attr.aria-label]="'Profile'"
            >
              <span class="flex w-5 shrink-0 items-center justify-center">
                <i class="pi pi-user text-base leading-none"></i>
              </span>
              @if (!sidebarCompressed()) {
                <span
                  class="grid grid-cols-1 overflow-x-hidden min-w-0"
                  animate.enter="enter-sidebar-text-animation"
                  animate.leave="leave-sidebar-text-animation"
                >
                  <span
                    class="min-w-0 overflow-x-hidden text-sm font-medium leading-normal whitespace-nowrap"
                    >Profile</span
                  >
                </span>
              }
            </button>
          } @else {
            <button
              type="button"
              (click)="onLogin()"
              class="flex h-[38px] items-center justify-start gap-2.5 px-2.5 rounded-lg transition-colors duration-200 w-full min-w-0 overflow-x-hidden text-surface-switch-600 hover:bg-surface-switch-50 hover:text-surface-switch-900"
              [attr.title]="sidebarCompressed() ? 'Login' : null"
              [attr.aria-label]="'Login'"
              pTooltip="Login"
              tooltipPosition="right"
              [showDelay]="150"
              [tooltipDisabled]="!sidebarCompressed()"
            >
              <span class="flex w-5 shrink-0 items-center justify-center">
                <i class="pi pi-sign-in text-base leading-none"></i>
              </span>
              @if (!sidebarCompressed()) {
                <span
                  class="grid grid-cols-1 overflow-x-hidden min-w-0"
                  animate.enter="enter-sidebar-text-animation"
                  animate.leave="leave-sidebar-text-animation"
                >
                  <span
                    class="min-w-0 overflow-x-hidden text-sm font-medium leading-normal whitespace-nowrap"
                    >Login</span
                  >
                </span>
              }
            </button>
          }
        </div>
      </div>
    </div>
  }

  <div
    class="h-full flex flex-1 min-w-0 overflow-hidden"
    [class.flex-row]="showShell()"
    [class.flex-col]="!showShell()"
  >
    <div
      class="@container h-full flex flex-col relative flex-1 min-w-0 overflow-hidden"
    >
      @if (showShell()) {
        <div
          class="flex items-center lg:hidden px-4 py-2 border-b border-surface-switch-200 bg-surface-switch-0"
        >
          <button
            type="button"
            pStyleClass="#app-sidebar-9"
            enterFromClass="hidden"
            enterActiveClass="animate-fadeinleft"
            leaveToClass="hidden"
            leaveActiveClass="animate-fadeoutleft"
            [hideOnOutsideClick]="true"
            class="cursor-pointer flex items-center justify-center text-surface-switch-500 bg-transparent border-0 p-0"
            aria-label="Open navigation"
            aria-controls="app-sidebar-9"
          >
            <i class="pi pi-bars text-lg!" aria-hidden="true"></i>
          </button>
        </div>
      }

      <div
        class="p-5 @3xl:p-6 @5xl:p-8 flex flex-col flex-auto min-w-0 bg-surface-switch-50 overflow-y-auto"
        [class.app-main-content]="showShell()"
      >
        <ng-content />
      </div>

      <ng-content select="[shellAgentFab]" />
    </div>

    <ng-content select="[shellAgentPanel]" />
  </div>
</div>

<p-dialog
  header="Profile"
  [modal]="true"
  [(visible)]="profileDialogVisible"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(26rem, 92vw)' }"
>
  <div class="flex flex-col items-center gap-5 py-2">
    <div
      class="flex h-20 w-20 items-center justify-center rounded-full bg-primary/15 text-primary"
      [attr.aria-label]="'User avatar'"
    >
      <i class="pi pi-user !text-3xl leading-none"></i>
    </div>
    <p
      class="max-w-full px-2 text-center text-lg text-surface-switch-700 break-all"
      [title]="userEmail()"
    >
      {{ userEmail() }}
    </p>
    <button
      type="button"
      pButton
      label="Sign Out"
      icon="pi pi-sign-out"
      severity="primary"
      (click)="onLogout()"
      class="mt-1"
      aria-label="Sign Out"
    ></button>
  </div>
</p-dialog>
